import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { CardSolidGame } from "./CardSolidGame";

import useLocations from "../hooks/useLocations";
import usePageTitle from "../hooks/usePageTitle";

function RestaurantList() {
  const { locations, error, loading } = useLocations();

  usePageTitle(`Food & Drink Spots | Fudopia | Meet. Eat. Repeat.`);

  return (
    <>
      {error && <p className="error-message">Something went wrong...</p>}
      <Typography variant="h1" component="div" sx={{ flexGrow: 0 }}>
        Food & Drink Spots
      </Typography>
      <div className="block-wrapper restaurants grid">
        {loading && (
          <Grid container spacing={4} sx={{ justifyContent: "space-between" }}>
            {[...Array(10)].map((x, i) => (
              <Grid key={i}>
                <Skeleton
                  animation="wave"
                  height={500}
                  width="21vw"
                  sx={{ marginRight: 5 }}
                />
              </Grid>
            ))}
          </Grid>
        )}
        {!loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 2,
            }}
          >
            <CardSolidGame locations={locations} />
          </Box>
        )}
      </div>
    </>
  );
}

export default RestaurantList;
